<template>
  <section class="sku_section sku-installment" v-if="antInstallment && antInstallment.perInstallmentInfoList">
    <div class="section_title">
      <span class="title">{{ title }}</span>
    </div>
    <div class="section_content">
      <div
        class="sku_btn"
        v-for="(installmentInfo, index) in antInstallment.perInstallmentInfoList"
        :key="index"
        :class="{ 'sku_btn--checked': fqNum == installmentInfo.num }"
        tabindex="0"
        @click="toggleInstallment(installmentInfo)"
      >
        <div :aria-label="fqNum == installmentInfo.num ? '已选中,' : '未选中,'"></div>
        <span
          class="name"
          :class="{ 'fixed-width': installmentInfo.userPerFeePay }"
          :aria-label="`${installmentInfo.perPay}元乘${installmentInfo.num}期`"
        >
          ¥{{ installmentInfo.perPay }}x{{ installmentInfo.num }}期
        </span>
        <template v-if="installmentInfo.userPerFeePay">
          <span class="item fs-30">含手续费</span>
        </template>
        <span class="badge" v-else>
          <i class="text">免息</i>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import { getInstallmentReq } from './api'
export default {
  name: 'SkuInstallment',
  props: {
    skuId: [Number, String],
    money: Number,
    fqNum: Number,
    installment: Object
  },
  data() {
    return {
      antInstallment: null, // 当前选择的sku对应的分期信息
      antInstallmentList: {} // 所有sku的花呗分期信息，以skuId + money 作为key, 只有自己请求分期信息时才会做缓存，否则取传递下来的数据
    }
  },
  computed: {
    title() {
      const ua = navigator.userAgent.toLowerCase()
      if (/Bankabc/i.test(ua)) {
        return '农行分期'
      } else {
        return '花呗分期'
      }
    },
    // 分期的依赖，如果这些依赖有变化，需要重新请求分期信息
    dep() {
      return {
        skuId: this.skuId,
        money: this.money
      }
    }
  },
  watch: {
    installment: {
      deep: true,
      immediate: true,
      handler(val) {
        this.antInstallment = val.hbInstallment
      }
    },
    // skuId和money变化时重新请求分期信息
    dep() {
      // this.$nextTick(this.getInstallmentInfo)
    }
  },
  created() {
    // this.getInstallmentInfo()
  },
  methods: {
    // 获取花呗信息
    getInstallmentInfo() {
      let key = this.skuId + '#' + this.money
      let current = this.antInstallmentList[key]
      // 当花呗信息已经存在时，直接切换成当前的
      if (!current) {
        getInstallmentReq({
          skuId: this.skuId || this.skuInfo.id,
          money: this.money
        }).then(
          data => {
            this.$set(this.antInstallmentList, key, data && data.antInstallment)
            this.antInstallment = data && data.antInstallment
          },
          () => {
            this.antInstallment = null
            // this.$toast(err && err.msg)
          }
        )
      } else {
        this.antInstallment = current
      }
    },
    // 切换分期信息
    toggleInstallment(installmentInfo) {
      this.$emit('fqNumChange', installmentInfo.num == this.fqNum ? 0 : installmentInfo.num)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4,
.vivo-fontscale-5 {
  .sku-installment .section_content .sku_btn {
    width: 750px;
    .fixed-width {
      width: auto;
    }
  }
}
</style>
